import { NavLink, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Brand } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";

export const TopNav = ({ links, sub, home, dark }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className={`sticky top-0 z-40 border-b ${dark ? "bg-zinc-950 border-zinc-800" : "bg-white/90 backdrop-blur-md border-zinc-200"}`}>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 h-16 flex items-center gap-6">
        <div className={dark ? "[&_span]:!text-white [&_.bg-zinc-950]:!bg-white" : ""}><Brand to={home} sub={sub} /></div>
        <nav className="flex-1 flex items-center gap-1 overflow-x-auto ml-4">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`nav-${l.id}`}
              className={({ isActive }) =>
                `flex items-center gap-2 h-16 px-3 text-sm font-medium whitespace-nowrap border-b-2 transition-colors duration-150 ${
                  isActive
                    ? `border-[#0D9488] ${dark ? "text-white" : "text-zinc-950"}`
                    : `border-transparent ${dark ? "text-zinc-400 hover:text-white" : "text-zinc-500 hover:text-zinc-950"}`
                }`
              }
            >
              <l.icon className="w-4 h-4" /> <span className="hidden sm:inline">{l.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:block text-right leading-tight">
          <p className={`text-sm font-semibold ${dark ? "text-white" : "text-zinc-950"}`} data-testid="nav-user-name">{user?.nome} {user?.cognome}</p>
          <p className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">{user?.role === "admin" ? "Super Admin" : `Classe ${user?.classe}`}</p>
        </div>
        <button
          data-testid="logout-btn"
          onClick={() => { logout(); nav(user?.role === "admin" ? "/admin/login" : "/login"); }}
          className={`w-10 h-10 grid place-items-center border transition-colors duration-150 ${dark ? "border-zinc-700 text-zinc-300 hover:bg-white hover:text-zinc-950" : "border-zinc-200 hover:bg-zinc-950 hover:text-white"}`}
          title="Esci"
        >
          <LogOut className="w-4 h-4" />
        </button>
      </div>
    </header>
  );
};
